// extracted by mini-css-extract-plugin
export default {"commentListWrapper":"CommentList_commentListWrapper__swyso","noComments":"CommentList_noComments__KcnM+","commentList":"CommentList_commentList__u63ai"};